<template>
	<div v-if="step === 0">
		<div class="d_flex align_items_center mb_16" @click="$emit('cancel')">
			<span class="LEFTARROW mr_8"></span>
			<h4 class="title_s tal">{{ $t('c2c.sell.title') }}</h4>
		</div>

		<p class="title_s mb_16">{{ $t('c2c.sell.title1') }}</p>
		<div>
			<p class="title_s mb_8">※{{ $t('c2c.sell.head1') }}</p>
			<p class="info_text body_m mb_16">
				{{ $t('c2c.sell.text1') }}<br />
				{{ $t('c2c.sell.text2') }}
			</p>
			<p class="title_s mb_8">※{{ $t('c2c.sell.head2') }}</p>
			<p class="info_text body_m mb_16">
				{{ $t('c2c.sell.text3') }}<br />
				{{ $t('c2c.sell.text4') }}<br />
				{{ $t('c2c.sell.text5') }}
			</p>
			<p class="title_s mb_8">※{{ $t('c2c.sell.head3') }}</p>
			<p class="info_text body_m mb_16">
				{{ $t('c2c.sell.text6') }}<br />
				{{ $t('c2c.sell.text7') }}
			</p>
			<p class="title_s mb_8">※{{ $t('c2c.sell.head4') }}</p>
			<p class="info_text body_m mb_40">
				{{ $t('c2c.sell.text8') }}<br />
				{{ $t('c2c.sell.text9') }}<br />
				{{ $t('c2c.sell.text10') }}
			</p>

			<button class="green button_m mb_8" @click="step++">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</div>
	<form @submit.prevent v-if="step === 1" class="m_sell_asset">
		<div class="d_flex align_items_center mb_16" @click="step--">
			<span class="LEFTARROW mr_8"></span>
			<h4 class="title_s tal">{{ $t('c2c.sell.title') }}</h4>
		</div>
		<div class="source_box">
			<CustomSelectBox
				ref="sourceSelect"
				:placeholder="$t('c2c.sell.placeholder1')"
				:options="sourceAssets"
				:show-account="true"
				@selectItem="selectSourceAsset"
			></CustomSelectBox>
		</div>
		<div class="down_arrow">
			<img src="@/assets/images/icon/arrow_down_m.png" alt="arrow_down.image" />
		</div>
		<div class="target_box mb_40">
			<CustomSelectBox
				ref="targetSelect"
				:placeholder="$t('c2c.sell.placeholder2')"
				:show-account="true"
				:disable="targetDisable"
				:options="targetAssets"
				@selectItem="selectTargetAsset"
			></CustomSelectBox>
		</div>
		<div class="tal registration_wrap">
			<div class="mb_16">
				<p class="mb_8">{{ $t('c2c.sell.head5') }}</p>
				<input
					type="text"
					class="tar"
					v-model="sourceAmount"
					placeholder="0"
					:disabled="!selectedMarket"
				/>
			</div>
			<div class="mb_16">
				<div class="d_flex align_items_center mb_8">
					<p class="mr_8">{{ $t('c2c.sell.head6') }}</p>
					<div class="switch_toggle">
						<label>
							<input
								type="checkbox"
								true-value="Y"
								false-value="N"
								v-model="useSourceMinAmount"
								:disabled="!selectedMarket"
							/>
							<span></span>
						</label>
					</div>
				</div>
				<input
					type="text"
					v-model="sourceMinAmount"
					class="tar"
					placeholder="0"
					:disabled="useSourceMinAmount === 'N'"
				/>
			</div>
			<div class="mb_16">
				<p class="mb_8">{{ $t('c2c.sell.head7') }}</p>
				<input
					type="text"
					class="bg tar"
					:disabled="spreadDisable"
					v-model="spreadRatio"
				/>
			</div>
			<div class="mb_40">
				<p class="mb_8">{{ $t('c2c.sell.head8') }}</p>
				<input
					v-if="!minDisable"
					type="text"
					class="tar"
					:disabled="minDisable"
					v-model="minPrice"
				/>
				<input v-else type="text" class="tar" :value="calcMinPrice" disabled />
			</div>
			<Extform
				class="border_t_black mt_20 pt_20"
				v-for="extform in extforms"
				:key="extform.seq"
				v-bind="extform"
				v-model="extform.field_values"
			/>
			<button
				class="button_m green mb_8 normal_submit"
				:disabled="!canRegistration"
				@click="sellHandler"
			>
				{{ $t('button.register') }}
			</button>
			<button class="button_m green mb_8 disabled_submit" disabled>
				{{ $t('button.register') }}
			</button>
		</div>
	</form>
	<ModalViewM
		v-if="accountRegistModal"
		@closeModal="accountRegistModal = false"
	>
		<template #title>
			<h3 class="modal_title_m tal">
				{{ $t('rtr_wallet_account-assets.title3') }}
			</h3>
		</template>
		<AccountRegister
			@closeRegist="closeRegist"
			:asset-info="selectedAsset"
		></AccountRegister>
	</ModalViewM>
	<ModalMessageM v-if="messageModal" @closeModal="closeMessageModal">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="mb_40">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'warning'">
			<button
				class="button_bg_red button_m"
				@click="(messageModal = false), (accountRegistModal = true)"
			>
				{{ $t('button.new_account') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'information'">
			<button class="button_bg_red button_m" @click="createPrivateDeal">
				{{ $t('button.confirm') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'success'">
			<button
				class="button_bg_red button_m"
				@click="(messageModal = false), $emit('success')"
			>
				{{ $t('button.confirm') }}
			</button>
		</div>
	</ModalMessageM>
</template>
<script>
import '@/assets/css/c2c.m.css';
import CustomSelectBox from '@/components/CustomSelectBox';
import { mapGetters } from 'vuex';
import { uniqBy } from 'lodash';
import { fetchPrivateMarkets, fetchPrivateMarketForms } from '@/api/market';
import { commonError } from '@/common/dialog';
import { createPrivateDeal } from '@/api/deal';
import ModalViewM from '@/components/Layout/ModalView.m';
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import AccountRegister from '@/components/AccountRegister';
import Extform from '@/components/Extform/Extform';

export default {
	name: 'C2cSell.m',
	emits: ['success', 'cancel'],
	components: {
		CustomSelectBox,
		ModalViewM,
		AccountRegister,
		ModalMessageM,
		Extform,
	},
	data() {
		return {
			step: 0,
			markets: [],
			selectedSourceSeq: '',
			selectedTargetSeq: '',
			selectedAssetSeq: null,
			sourceAmount: null,
			target: '',
			newAssetSeq: '',
			useSourceMinAmount: 'N',
			useSourceMaxAmount: 'N',
			useMinPrice: 'N',
			useMaxPrice: 'N',
			minPrice: '',
			sourceMinAmount: '',
			spreadRatio: '',
			messageModalMode: '',
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			accountRegistModal: false,
			extforms: [],
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		...mapGetters('assets', ['assets', 'registedAssets']),
		sourceAssets() {
			const result = [];
			this.markets.forEach(market => {
				const asset = this.registedAssets.find(asset => {
					return asset.seq === market.source_asset_seq;
				});
				if (asset) result.push(asset);
			});
			return uniqBy(result, 'seq');
		},
		targetAssets() {
			const result = [];
			this.markets.forEach(market => {
				const asset = this.registedAssets.find(asset => {
					return (
						market.source_asset_seq === this.selectedSourceSeq &&
						asset.seq === market.target_asset_seq
					);
				});
				if (asset) result.push(asset);
			});
			return uniqBy(result, 'seq');
		},
		selectedSourceAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === this.selectedSourceSeq;
			});
		},
		selectedTargetAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === this.selectedTargetSeq;
			});
		},
		selectedSourceAsset() {
			return this.registedAssets.find(item => {
				return item.seq === this.selectedSourceSeq;
			});
		},
		selectedTargetAsset() {
			return this.registedAssets.find(item => {
				return item.seq === this.selectedTargetSeq;
			});
		},
		selectedMarket() {
			return this.markets.find(item => {
				return (
					item.source_asset_seq === this.selectedSourceSeq &&
					item.target_asset_seq === this.selectedTargetSeq
				);
			});
		},
		targetDisable() {
			return (
				this.selectSourceAsset.is_active === 'Y' && !this.selectedSourceAccount
			);
		},
		spreadDisable() {
			return !(
				this.selectedMarket &&
				this.selectedMarket.use_follow_direct_market === 'Y'
			);
		},
		minDisable() {
			return !(
				this.selectedMarket &&
				this.selectedMarket?.use_follow_direct_market === 'N'
			);
		},
		selectedAsset() {
			return this.registedAssets.find(item => {
				return item.seq === this.selectedAssetSeq;
			});
		},
		canRegistration() {
			if (this.selectedMarket) {
				if (this.selectedMarket.use_follow_direct_market === 'N') {
					return !!this.sourceAmount && !!this.minPrice;
				} else {
					return !!this.sourceAmount && !!this.spreadRatio;
				}
			} else {
				return false;
			}
		},
		calcMinPrice() {
			if (
				this.selectedMarket &&
				this.selectedMarket.use_follow_direct_market === 'Y'
			) {
				return this.selectedMarket.direct_market_basic_rate * this.spreadRatio;
			} else {
				return null;
			}
		},
	},
	mounted() {
		this.init();
	},
	watch: {
		selectedSourceSeq() {
			this.selectedTargetSeq = '';
			if (this.$refs.targetSelect) this.$refs.targetSelect.initSelected();
		},
		sourceAmount(value) {
			if (!value) return;
			this.sourceAmount = value
				.replace(/[^0-9.]/g, '')
				.replace(/(\..*)\./g, '$1');
		},
		selectedMarket(value) {
			if (value && value.use_follow_direct_market === 'Y') this.spreadRatio = 1;
			else this.spreadRatio = '';

			this.sourceAmount = null;
			this.minPrice = '';
			this.useSourceMinAmount = 'N';
			this.sourceMinAmount = '';
			this.loadExtforms();
		},
		step(value) {
			if (value === 1) {
				this.initForm();
			}
			window.scrollTo(0, 0);
		},
	},
	methods: {
		closeMessageModal() {
			if (this.messageModalMode === 'success') {
				this.initForm();
				window.scrollTo(0, 0);
			} else {
				this.messageModal = false;
			}
		},
		init() {
			this.loadPrivateMarkets();
		},
		async loadPrivateMarkets() {
			const { data } = await fetchPrivateMarkets().catch(commonError);
			this.markets = data.filter(item => {
				return item.is_active === 'Y';
			});
		},
		async loadExtforms() {
			this.extforms = [];
			if (!this.selectedMarket) return;

			const { forms } = await fetchPrivateMarketForms(
				this.selectedMarket.seq,
				'MARKET_PRIVATE_DEAL',
			).catch(commonError);
			this.extforms = forms.map(item => ({ ...item, field_values: [] }));
		},
		checkAccount(target) {
			const assetSeq =
				target === 'source' ? this.selectedSourceSeq : this.selectedTargetSeq;
			const account = this.accounts.find(item => {
				return item.asset_seq === assetSeq;
			});
			const asset = this.registedAssets.find(item => {
				return item.seq === assetSeq;
			});

			if (account || asset.is_active !== 'Y') return;

			this.selectedAssetSeq = assetSeq;
			this.target = target;
			if (target === 'source') {
				this.newAssetSeq = this.selectedSourceSeq;
				this.selectedSourceSeq = '';
				this.$refs.sourceSelect.initSelected();
			} else {
				this.newAssetSeq = this.selectedTargetSeq;
				this.selectedTargetSeq = '';
				this.$refs.targetSelect.initSelected();
			}
			this.modalStatusMessage = this.$t('modal.message.no_account');
			this.modalIcon = 'warning';
			this.messageModalMode = 'warning';
			this.messageModal = true;
		},
		selectSourceAsset(assetSeq) {
			this.selectedSourceSeq = assetSeq;
			this.checkAccount('source');
		},
		selectTargetAsset(assetSeq) {
			this.selectedTargetSeq = assetSeq;
			this.checkAccount('target');
		},
		closeRegist(seq) {
			if (seq) {
				const accountInfo = this.accounts.find(item => {
					return item.seq === seq;
				});
				this.target === 'source'
					? this.$refs.sourceSelect.selectItem(accountInfo.asset_seq)
					: this.$refs.targetSelect.selectItem(accountInfo.asset_seq);
			}
			this.accountRegistModal = false;
		},
		initForm() {
			this.messageModal = false;
			this.selectedSourceSeq = '';
			this.selectedTargetSeq = '';
			this.sourceAmount = null;
			this.sourceMinAmount = '';
			this.spreadRatio = '';
			this.minPrice = '';
			this.useSourceMinAmount = 'N';
			if (this.$refs.sourceSelect) this.$refs.sourceSelect.initSelected();
			if (this.$refs.targetSelect) this.$refs.targetSelect.initSelected();
		},
		sellHandler() {
			this.modalIcon = 'information';
			this.messageModalMode = 'information';
			this.modalStatusMessage = this.$t('modal.message.set_sell');
			this.messageModal = true;
		},
		async createPrivateDeal() {
			const params = {
				market_seq: this.selectedMarket.seq,
				account_seq: this.selectedSourceAccount?.seq,
				target_account_seq: this.selectedTargetAccount?.seq,
				source_amount: this.sourceAmount,
				use_source_min_amount: this.useSourceMinAmount,
				source_min_amount:
					this.useSourceMinAmount === 'Y' ? this.sourceMinAmount : '',
				use_source_max_amount: this.useSourceMaxAmount,
				source_max_amount: '',
				use_min_price: this.useMinPrice,
				use_max_price: this.useMaxPrice,
				min_price: this.minPrice,
				max_price: '',
				spread_ratio: this.spreadRatio,
				field_values: [].concat(
					...this.extforms.map(item => item.field_values),
				),
			};
			await createPrivateDeal(params)
				.then(() => {
					this.$store.dispatch('account/getAccounts');
					this.modalIcon = 'success';
					this.messageModalMode = 'success';
					this.modalStatusMessage = this.$t('modal.message.registered');
					this.messageModal = true;
				})
				.catch(e => {
					this.messageModal = false;
					commonError(e);
				});
		},
	},
};
</script>

<style scoped>
.m_sell_asset:invalid .normal_submit {
	display: none;
}
.m_sell_asset:valid .disabled_submit {
	display: none;
}
</style>
